/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VendorErrorSeverity = {
    UnknownEvent: 'UNKNOWN_EVENT',
    Info: 'INFO',
    Warn: 'WARN',
    Err: 'ERR',
    Fatal: 'FATAL'
} as const;
export type VendorErrorSeverity = typeof VendorErrorSeverity[keyof typeof VendorErrorSeverity];


export function instanceOfVendorErrorSeverity(value: any): boolean {
    for (const key in VendorErrorSeverity) {
        if (Object.prototype.hasOwnProperty.call(VendorErrorSeverity, key)) {
            if (VendorErrorSeverity[key as keyof typeof VendorErrorSeverity] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VendorErrorSeverityFromJSON(json: any): VendorErrorSeverity {
    return VendorErrorSeverityFromJSONTyped(json, false);
}

export function VendorErrorSeverityFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorErrorSeverity {
    return json as VendorErrorSeverity;
}

export function VendorErrorSeverityToJSON(value?: VendorErrorSeverity | null): any {
    return value as any;
}

export function VendorErrorSeverityToJSONTyped(value: any, ignoreDiscriminator: boolean): VendorErrorSeverity {
    return value as VendorErrorSeverity;
}

